module.exports = __webpack_public_path__ + "img/fe_logo_mask3.964b25fa.png";